module.exports = __webpack_public_path__ + "img/austria-external-causes-female.d8955ade.png";